import { render, staticRenderFns } from "./MsTextArea.vue?vue&type=template&id=6618411e&scoped=true"
import script from "./MsTextArea.vue?vue&type=script&lang=js"
export * from "./MsTextArea.vue?vue&type=script&lang=js"
import style0 from "./MsTextArea.vue?vue&type=style&index=0&id=6618411e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6618411e",
  null
  
)

export default component.exports